(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 1430:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(4697);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_contact; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_@babel+core@7.17.5_react-dom@17.0.2_react@17.0.2_sass@1.49.9/node_modules/next/script.js
var script = __webpack_require__(9029);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./src/layout/index.ts + 16 modules
var layout = __webpack_require__(7818);
// EXTERNAL MODULE: ./src/layouts/index.ts + 2 modules
var layouts = __webpack_require__(2039);
// EXTERNAL MODULE: ./src/utils/index.ts + 10 modules
var utils = __webpack_require__(7925);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_@babel+core@7.17.5_react-dom@17.0.2_react@17.0.2_sass@1.49.9/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(8140);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+button@1.5.8_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 2 modules
var chakra_ui_button_esm = __webpack_require__(9563);
// EXTERNAL MODULE: ./node_modules/.pnpm/formik@2.2.9_react@17.0.2/node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(431);
// EXTERNAL MODULE: ./src/components/index.ts + 4 modules
var components = __webpack_require__(3890);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.1.2_react-dom@17.0.2_react@17.0.2/node_modules/react-bootstrap/esm/Button.js + 1 modules
var Button = __webpack_require__(9556);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.1.2_react-dom@17.0.2_react@17.0.2/node_modules/react-bootstrap/esm/Modal.js + 60 modules
var Modal = __webpack_require__(3198);
// EXTERNAL MODULE: ./src/views/contact/sections/privacy-policy-modal.module.scss
var privacy_policy_modal_module = __webpack_require__(5525);
var privacy_policy_modal_module_default = /*#__PURE__*/__webpack_require__.n(privacy_policy_modal_module);
;// CONCATENATED MODULE: ./src/views/contact/sections/privacy-policy-modal.tsx






var PrivacyPolicyModal = function(param) {
    var handleAccept = param.handleAccept, handleHide = param.handleHide, show = param.show;
    var isMobile = (0,utils/* useGridProps */.by)().isMobile;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            className: (privacy_policy_modal_module_default()).modal,
            "aria-labelledby": "contained-modal-title-vcenter",
            centered: true,
            onHide: handleHide,
            show: show,
            scrollable: isMobile,
            size: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    className: (privacy_policy_modal_module_default()).header,
                    closeButton: isMobile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                        id: "contained-modal-title-vcenter",
                        className: (privacy_policy_modal_module_default()).title,
                        children: "㈜이노앤엠 개인정보처리방침"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (privacy_policy_modal_module_default()).body,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    "주식회사 이노앤엠(“회사”또는 “이노앤엠”라 함)는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법, 통신비밀보호법, 전기통신사업법 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "1. 수집하는 개인정보의 항목 및 수집방법",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "2. 개인정보의 수집 및 이용목적",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "3. 개인정보 공유 및 제공",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "4. 개인정보의 보유 및 이용기간",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "5. 개인정보 파기절차 및 방법",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "6. 이용자 및 법정대리인의 권리와 그 행사방법",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "7. 개인정보 자동 수집 장치의 설치 / 운영 및 거부에 관한 사항",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "8. 개인정보의 기술적 / 관리적 보호 대책",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "9. 개인정보관리책임자 및 담당자의 연락처",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "10. 개인정보 처리 방침 변경",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "11. 고지의 의무"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "1. 수집하는 개인정보의 항목 및 수집방법"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "가. 수집하는 개인정보의 항목",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "첫째, 회사는 이용자에게 서비스를 제공하기 위해 아래와 같은 최소한의 고객의 개인정보를 수집하고 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "[광고문의]",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 수집항목 : 이용자명(개인인 경우 이름, 개인사업자 또는 법인사업자인 경우 상호명), 전화번호(휴대폰번호), 이메일이 수집됩니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "둘째, 회사의 홈페이지를 접속하는 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "셋째, 회사에서 제공하는 제품을 배송하기 위하여, 배송 받으실 주소를 수집할 수 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "나. 개인정보 수집방법",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "회사는 다음과 같은 방법으로 개인정보를 수집합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 홈페이지 주소 문의자 이름, 업체명 , 유선 연락처 번호 , 무선 연락처 번호 , 이메일등",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "2. 개인정보의 수집 및 이용목적"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "[마케팅 • 광고의 활용]",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "이벤트 등 광고성 정보 전달, 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 접속빈도 파악 등 회사의 서비스 이용에 대한 통계",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "3. 개인정보의. 공유 및 제공"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "회사는 이용자들의 개인정보를 제 2항 ‘개인정보의 수집목적 및 이용목적’에서 고지한 범위 내에서 사용하고, 이용자의 사전 동의 없이는 위 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 그리고, 이용자의 개인정보를 외부와 공유하는 경우에는 정보수집 또는 정보제공 이전에 이용자들에게 개인정보를 공유할 기관이나 단체가 누구인지, 어떤 정보가 왜 필요한지, 언제까지 어떻게 보호되고 관리되는지 알려드리고 동의를 구하는 절차를 거치게 되며, 이용자들의 동의가 없는 경우에는 추가적인 정보를 임의로 수집하거나 공유하지 않습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "다만, 아래의 경우에는 예외로 합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "가. 이용자가 사전에 동의한 경우",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "나. 통계작성, 학술연구 또는 시장조사를 위하여 개인을 식별할 수 없는 형태로 제공하는 경우",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "다. 회사 이용 약관 또는 계약을 위반한 경우나 회사의 서비스를 이용하여 타인에게 정신적, 물질적 피해를 줌으로써 글에 대한 법적인 조치를 취하기 위하여 개인정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "라. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사시관의 요구가 있는 경우"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "4. 개인정보의 보유 및 이용기간"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 보존 이유를 위해 명시한 기간 동안 보존합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "가. 회사 내부 방침에 의한 정보 보유 기간",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 이용자의 정보 수집 및 이용 목적이 달성된 후 문의 내역관리를 위하여 문의 내용과 개인정보 입력항목에 대해서는 6개월간 보유 합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 이용자와 회사간의 계약 종료 시 이용자의 개인정보는 계약기간이 종료된 시점으로부터 1년간 보유 합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 회사가 이용자에게 견적을 제공한 후 계약이 체결되지 않았을 경우 이용자의 개인정보는 견적을 제공한 시점으로부터 6개월간 보유 합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "나. 관련법령에 의한 정보 보유 기간",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "개인정보보호법 및 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 “정보통신망법”이라 합니다) 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 계약 또는 계약 종료 등에 관한 기록",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "보존 이유 : 하도급거래 공정화에 관한 법률 및 시행령",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "보존 기간 : 3년",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 웹사이트 방문기록",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "보존 이유 : 통신비밀보호법 시행령",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "보존 기간 : 3개월"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "5. 개인정보 파기절차 및 방법"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기 합니다,",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "회사의 개인정보 파기절차 및 방법은 다음과 같습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "가. 파기절차",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기 됩니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "나. 파기방법",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "6. 이용자의 정보주체의 권리와 그 행사 방법"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 이용자 개인 정보 열람 요구 시 회사는 지체 없이 열람하겠습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 이용자 오류 등이 있을 경우 정정 요구 시 회사는 지체 없이 정정하겠습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 이용자 개인 정보 삭제 요구 시 회사는 지체 없이 삭제하겠습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락해주시면 지체 없이 조치하겠습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 제 4.항 ‘개인정보의 보유 및 이용기간’에 명시된 바에 따라 처리하고, 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "7. 개인정보 자동 수집 장치의 설치 / 운영 및 거부에 관한 사항"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "가. 쿠키란?",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다. 이후 이용자가 웹 사이트에 방문할 경우 웹 사이트 서버는 이용자의 하드 디스크에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하기 위해 이용됩니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 쿠키는 개인을 식별하는 정보를 자동적 / 능동적으로 수집하지 않으며, 이용자는 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "나. 회사의 쿠키 사용 목적",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "이용자의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 횟수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공을 위해 사용합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "다. 쿠키의 설치 / 운영 및 거부",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 쿠키 설치 허용 여부를 지정하는 방법(Internet Explorer의 경우)은 다음과 같습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "① [도구] 메뉴에서 [인터넷 옵션]을 선택합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "② [개인정보 탭]을 클릭합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "③ [개인정보처리 수준]을 설정하시면 됩니다."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "8. 개인정보의 기술적 / 관리적 보호 대책"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손 되지 않도록 안정성 확보를 위하여 다음과 같은 기술적 / 관리적 대책을 강구하고 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "가. 개인정보 암호화",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "이용자 및 고객의 개인정보는 고도몰 웹호스팅 서비스를 통해 저장 및 관리되고 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "나. 해킹 등에 대비한 대책",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지 않도록 방지하고 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "다. 처리 직원의 최소화 및 교육",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위해 담당자에 대한 수시 교육을 통하여 개인정보처리방침의 준수를 항상 강조하고 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "라. 개인정보보호전담기구의 운영",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "그리고 사내 개인정보보호전담 부서 등을 통하여 개인정보처리방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "단, 회사가 개인정보보호 의무를 다 하였음에도 불구하고 이용자 본인의 부주의나 회사가 관리하지 않는 영역에서의 사고 등 회사의 귀책에 기인하지 않은 손해에 대해서는 회사는 책임을 지지 않습니다."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "9. 개인정보관리책임자 및 담당자의 연락처"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "회사는 이용자 등의 신고사항에 대해 신속하고 충분한 답변을 드릴 것입니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "[개인정보 보호책임자]",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "성 명 : 박 관 희",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "소 속 : ㈜",
                                    (0,utils.t)("company.brandKO"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "전 화 : 010-3928-8492",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "이메일 : ",
                                    (0,utils.t)("company.contactEmail")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "10. 개인정보 처리 방침 변경"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "본 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.,",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 대검찰청 사이버범죄수사단 (www.spo.go.kr / 02-3480-3571)",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 경찰청 사이버안전국 (www.ctrc.go.kr / 국번없이 182)",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "– 개인정보마크인증위원회(www.epivacy.or.kr / 02-580-0533 ~ 4)"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (privacy_policy_modal_module_default()).phrase,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: (privacy_policy_modal_module_default()).subtitle,
                                        children: "11. 고지의 의무"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "본 개인정보처리방침은 2021년 7월 15일부터 시행합니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "본 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지를 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다."
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Footer */.Z.Footer, {
                    className: (privacy_policy_modal_module_default()).footer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: (privacy_policy_modal_module_default()).button,
                        size: "lg",
                        onClick: handleAccept,
                        children: "동의합니다"
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var privacy_policy_modal = (PrivacyPolicyModal);

;// CONCATENATED MODULE: ./src/views/contact/sections/contact.tsx









function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var log = (0,utils/* createLog */.xN)("ContactSection");
var ThemedTextInput = function(param) {
    var name = param.name, type = param.type, // OPTIONAL
    id = param.id, label = param.label, placeholder = param.placeholder, _required = param.required, required = _required === void 0 ? false : _required;
    var props = {
        name: name,
        type: type,
        id: id,
        placeholder: placeholder,
        required: required
    };
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and alse replace ErrorMessage entirely.
    var ref = _slicedToArray((0,formik_esm/* useField */.U$)(props), 2), field = ref[0], meta = ref[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: props.id || props.name,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                className: "textInput"
            }, field, props)),
            meta.touched && meta.error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "error",
                children: meta.error
            }) : null
        ]
    }));
};
var ThemedTextarea = function(param) {
    var name = param.name, // OPTIONAL
    id = param.id, label = param.label, placeholder = param.placeholder, _required = param.required, required = _required === void 0 ? false : _required, rows = param.rows;
    var props = {
        name: name,
        id: id,
        placeholder: placeholder,
        required: required,
        rows: rows
    };
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and alse replace ErrorMessage entirely.
    var ref = _slicedToArray((0,formik_esm/* useField */.U$)(props), 2), field = ref[0], meta = ref[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "textAreaLabel",
                htmlFor: props.id || props.name,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", _objectSpread({
                className: "textArea"
            }, field, props)),
            meta.touched && meta.error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "error",
                children: meta.error
            }) : null
        ]
    }));
};
var ThemedCheckbox = function(param) {
    var children = param.children, name = param.name, checked = param.checked, onClick = param.onClick, _required = param.// OPTIONAL
    required, required = _required === void 0 ? false : _required;
    var props = {
        name: name,
        checked: checked,
        onClick: onClick,
        required: required
    };
    var ref = _slicedToArray((0,formik_esm/* useField */.U$)(_objectSpread({}, props, {
        type: "checkbox"
    })), 2), field = ref[0], meta = ref[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "checkbox",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, field, props, {
                        type: "checkbox"
                    })),
                    children
                ]
            }),
            meta.touched && meta.error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "error",
                children: meta.error
            }) : null
        ]
    }));
};
// const ThemedSelect = ({label, ...props}) => {
//   // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
//   // which we can spread on <input> and alse replace ErrorMessage entirely.
//   const [field, meta] = useField(props);
//   return (
//     <>
//       <label className='selectLabel' htmlFor={props.id || props.name}>
//         {label}
//       </label>
//       <select className='select' {...field} {...props} />
//       {meta.touched && meta.error ? (
//         <div className='error'>{meta.error}</div>
//       ) : null}
//     </>
//   );
// };
// And now we can use these
var ContactForm = function() {
    var ref = _slicedToArray((0,utils/* useStateL */.Fs)(false, "modalShow"), 2), modalShow = ref[0], setModalShow = ref[1];
    var ref1 = _slicedToArray((0,utils/* useStateL */.Fs)(false, "acceptTerms"), 2), acceptTerms = ref1[0], setAcceptTerms = ref1[1];
    var handleClickAcceptTerms = function() {
        log.debug("TERMS");
        if (acceptTerms) {
            setAcceptTerms(false);
        } else {
            setAcceptTerms(true);
        // setModalShow(true);
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: {
                    corpName: "",
                    name: "",
                    email: "",
                    acceptTerms: false
                },
                validateOnBlur: false,
                validateOnChange: false,
                onSubmit: function() {
                    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values, param) {
                        var setSubmitting, resetForm /* , validate */ ;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    setSubmitting = param.setSubmitting, resetForm = param.resetForm;
                                    log.info("Submit ContactForm: ".concat(JSON.stringify(values, null, 2)));
                                    setSubmitting(true);
                                    _ctx.prev = 3;
                                    _ctx.next = 6;
                                    return fetch("/api/mail", {
                                        method: "POST",
                                        headers: {
                                            'Accept': "application/json, text/plain, */*",
                                            'Content-Type': "application/json"
                                        },
                                        body: JSON.stringify(values)
                                    });
                                case 6:
                                    alert("문의사항이 접수되었습니다.");
                                    log.info("ContactForm submitted successfully.");
                                    _ctx.next = 15;
                                    break;
                                case 10:
                                    _ctx.prev = 10;
                                    _ctx.t0 = _ctx["catch"](3);
                                    alert("오류가 발생했습니다.");
                                    log.error("Error occurred while submitting ContactForm.");
                                    log.error(_ctx.t0);
                                case 15:
                                    _ctx.prev = 15;
                                    setSubmitting(false);
                                    resetForm();
                                    return _ctx.finish(15);
                                case 19:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                3,
                                10,
                                15,
                                19
                            ]
                        ]);
                    }));
                    return function(values, _) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                    className: "form",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                            className: "formRow",
                            align: "flex-start",
                            flexDir: {
                                base: "column",
                                md: "row"
                            },
                            justify: "space-around",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                    className: "formCol",
                                    maxW: "100%",
                                    minW: {
                                        md: "21rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedTextInput, {
                                            placeholder: "업체명",
                                            name: "corpName",
                                            type: "text",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedTextInput, {
                                            placeholder: "연락처",
                                            name: "phoneNum",
                                            type: "text",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedTextInput, {
                                            placeholder: "홈페이지 주소",
                                            name: "homepage",
                                            type: "text",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                    className: "formCol",
                                    maxW: "100%",
                                    minW: {
                                        md: "21rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedTextInput, {
                                            placeholder: "담당자명",
                                            name: "name",
                                            type: "text",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedTextInput, {
                                            placeholder: "이메일",
                                            name: "email",
                                            type: "email",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedTextInput, {
                                            placeholder: "광고예산",
                                            name: "budget",
                                            type: "text",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                    className: "formCol",
                                    maxW: "100%",
                                    minW: {
                                        md: "21rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedTextarea, {
                                            name: "message",
                                            label: "문의내용",
                                            rows: 4,
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedCheckbox, {
                                            name: "acceptTerms",
                                            checked: acceptTerms,
                                            onClick: function() {
                                                return handleClickAcceptTerms();
                                            },
                                            required: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextUnderline */.nC, {
                                                        colorLight: "white",
                                                        underlineColorLight: "gray.500",
                                                        underlineHeight: "20%",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                                                            className: "link",
                                                            borderBottom: "1px solid",
                                                            onClick: function() {
                                                                return setModalShow(true);
                                                            },
                                                            variant: "link",
                                                            children: "개인정보 처리방침"
                                                        })
                                                    }),
                                                    "에 동의합니다"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "buttonWrap",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "submit",
                                children: "문의 등록"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(privacy_policy_modal, {
                handleAccept: function() {
                    setModalShow(false);
                    setAcceptTerms(true);
                },
                handleHide: function() {
                    return setModalShow(false);
                },
                show: modalShow
            })
        ]
    }));
};
var ContactSection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: "contact",
        sectionType: layout/* SectionType.DARK */.bA.DARK,
        title: (0,utils.t)("view.sections.contact.title"),
        titleProps: {
            fontSize: {
                base: "2.8rem",
                md: "4rem"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {})
    });
};
/* harmony default export */ var contact = (ContactSection);

// EXTERNAL MODULE: ./configs/index.ts + 5 modules
var configs = __webpack_require__(9457);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+media-query@2.0.4_@chakra-ui+system@1.11.2_@chakra-ui+theme@1.14.0_react@17.0.2/node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(6798);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(9803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/kakao-map.module.scss
var kakao_map_module = __webpack_require__(3613);
var kakao_map_module_default = /*#__PURE__*/__webpack_require__.n(kakao_map_module);
;// CONCATENATED MODULE: ./src/components/kakao-map.tsx






function kakao_map_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function kakao_map_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return kakao_map_arrayLikeToArray(arr);
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function kakao_map_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function kakao_map_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function kakao_map_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function kakao_map_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            kakao_map_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function kakao_map_slicedToArray(arr, i) {
    return kakao_map_arrayWithHoles(arr) || kakao_map_iterableToArrayLimit(arr, i) || kakao_map_unsupportedIterableToArray(arr, i) || kakao_map_nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || kakao_map_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function kakao_map_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return kakao_map_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kakao_map_arrayLikeToArray(o, minLen);
}
var kakao_map_log = (0,utils/* createLog */.xN)("KakaoMap");
var LocationOverlay = function(param) {
    var // OPTIONAL
    containerProps = param.containerProps;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, kakao_map_objectSpread({
        align: "center",
        bottom: {
            base: "0",
            md: "15%"
        },
        justify: "flex-start",
        pos: "absolute",
        px: 16,
        right: {
            base: "0",
            md: "5%"
        },
        zIndex: 2,
        sx: {
            backdropFilter: "blur(16px) saturate(180%)",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            borderRadius: {
                base: 0,
                md: "20px"
            },
            border: "1px solid rgba(209, 213, 219, 0.3)"
        }
    }, containerProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                    mb: {
                        base: 6,
                        md: 12
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            textStyle: "content.title-xs",
                            children: "ADDRESS"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            textStyle: "content.body-sm",
                            children: (0,utils.t)("company.address1")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            textStyle: "content.body-sm",
                            children: (0,utils.t)("company.address2")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            textStyle: "content.title-xs",
                            children: "DIRECTION"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            textStyle: "content.body-sm",
                            children: (0,utils.t)("company.direction")
                        })
                    ]
                })
            ]
        })
    }));
};
var KakaoMap = function(param) {
    var apiKey = param.apiKey, centerLatLng = param.centerLatLng, height = param.height, _borderRadius = param.// OPTIONAL
    borderRadius, borderRadius = _borderRadius === void 0 ? 0 : _borderRadius, _disableMap = param.disableMap, disableMap = _disableMap === void 0 ? false : _disableMap, _draggable = param.draggable, draggable = _draggable === void 0 ? true : _draggable, markerPositions = param.markerPositions, width = param.width, tmp = param.zoomLevel, zoomlevel = tmp === void 0 ? 3 : tmp, _zoomable = param.zoomable, zoomable = _zoomable === void 0 ? false : _zoomable;
    var ref = kakao_map_slicedToArray((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)("(max-width: 48em)"), 1), isMobile = ref[0];
    var ref1 = kakao_map_slicedToArray((0,utils/* useStateL */.Fs)(undefined, "kakaoMap"), 2), kakaoMap = ref1[0], setKakaoMap = ref1[1];
    var ref2 = kakao_map_slicedToArray((0,utils/* useStateL */.Fs)([], "markers"), 2), setMarkers = ref2[1];
    var container = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!centerLatLng) return;
        var script = document.createElement("script");
        script.src = "https://dapi.kakao.com/v2/maps/sdk.js?appkey=".concat(apiKey, "&autoload=false");
        document.head.appendChild(script);
        script.onload = function() {
            kakao.maps.load(function() {
                var addToLat = isMobile ? -0.004 : 0;
                var addToLng = isMobile ? -0.001 : 0.008;
                var center = new kakao.maps.LatLng(centerLatLng[0] + addToLat, centerLatLng[1] + addToLng);
                var options = {
                    center: center,
                    level: zoomlevel
                };
                var map = new kakao.maps.Map(container.current, options);
                setKakaoMap(map);
            });
        };
    }, [
        apiKey,
        centerLatLng,
        isMobile,
        setKakaoMap,
        zoomlevel
    ]);
    (0,react.useEffect)(function() {
        if (kakaoMap && container && container.current) {
            // save center position
            var center = kakaoMap.getCenter();
            // change viewport size
            if (width) container.current.style.width = "".concat(width, "px");
            if (height) container.current.style.height = "".concat(height, "px");
            // relayout and...
            kakaoMap.relayout();
            // restore
            kakaoMap.setCenter(center);
        }
    }, [
        height,
        kakaoMap,
        width
    ]);
    (0,react.useEffect)(function() {
        if (kakaoMap) {
            kakao_map_log.debug("kakaoMap.setDraggable(".concat(draggable, ");"));
            kakaoMap.setDraggable(draggable);
        }
    }, [
        draggable,
        kakaoMap
    ]);
    (0,react.useEffect)(function() {
        if (kakaoMap) {
            kakao_map_log.debug("kakaoMap.setZoomable(".concat(zoomable, ");"));
            kakaoMap.setZoomable(zoomable);
        }
    }, [
        kakaoMap,
        zoomable
    ]);
    (0,react.useEffect)(function() {
        if (kakaoMap && markerPositions) {
            var positions = markerPositions.map(function(pos) {
                return _construct(kakao.maps.LatLng, _toConsumableArray(pos));
            });
            setMarkers(function(markers) {
                // clear prev markers
                markers.forEach(function(marker) {
                    return marker.setMap(null);
                });
                // assign new markers
                return positions.map(function(pos) {
                    return new kakao.maps.Marker({
                        map: kakaoMap,
                        position: pos
                    });
                });
            });
        }
    }, [
        kakaoMap,
        markerPositions,
        setMarkers
    ]);
    var handleClickZoomIn = function() {
        if (kakaoMap) {
            kakaoMap.setLevel(kakaoMap.getLevel() - 1);
        }
    };
    var handleClickZoomOut = function() {
        if (kakaoMap) {
            kakaoMap.setLevel(kakaoMap.getLevel() + 1);
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        id: "container",
        className: (kakao_map_module_default()).container,
        ref: container,
        style: {
            position: "relative"
        },
        borderRadius: borderRadius,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOverlay, {
                containerProps: {
                    w: {
                        base: "100%",
                        md: "31%"
                    },
                    h: {
                        base: "40%",
                        md: "70%"
                    },
                    borderRadius: borderRadius
                }
            }),
            disableMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "KAKAOMAP DISABLED"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (kakao_map_module_default()).zoomControl,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: classnames_default()((kakao_map_module_default()).button, (kakao_map_module_default()).zoomIn),
                        onClick: handleClickZoomIn,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/ico_plus.png",
                            alt: "확대"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: classnames_default()((kakao_map_module_default()).button, (kakao_map_module_default()).zoomOut),
                        onClick: handleClickZoomOut,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/ico_minus.png",
                            alt: "축소"
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var kakao_map = (KakaoMap);

// EXTERNAL MODULE: ./src/layout/section.tsx
var section = __webpack_require__(2179);
;// CONCATENATED MODULE: ./src/views/contact/sections/location.tsx







function location_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function location_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function location_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function location_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function location_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function location_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            location_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function location_slicedToArray(arr, i) {
    return location_arrayWithHoles(arr) || location_iterableToArrayLimit(arr, i) || location_unsupportedIterableToArray(arr, i) || location_nonIterableRest();
}
function location_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return location_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return location_arrayLikeToArray(o, minLen);
}
var UNIT_NAME = "LocationSection";
var LocationSection = function() {
    var isMobile = (0,utils/* useGridProps */.by)().isMobile;
    var log = (0,utils/* useLog */.Tx)(UNIT_NAME);
    var ref = location_slicedToArray((0,utils/* useStateL */.Fs)(configs/* Configs.getKakaoMapConfigs */.zo.getKakaoMapConfigs(log, isMobile), "kakaoMapConfigs"), 2), kakaoMapConfigs = ref[0], setKakaoMapConfigs = ref[1];
    var ref1 = location_slicedToArray((0,utils/* useStateL */.Fs)(configs/* Configs.getEnvVars */.zo.getEnvVars().kakaoMapApiKey, "kakaoMapApiKey"), 2), kakaoMapApiKey = ref1[0], setKakaoMapApiKey = ref1[1];
    (0,react.useEffect)(function() {
        setKakaoMapConfigs(configs/* Configs.getKakaoMapConfigs */.zo.getKakaoMapConfigs(log, isMobile));
        setKakaoMapApiKey(configs/* Configs.getEnvVars */.zo.getEnvVars().kakaoMapApiKey);
    }, [
        isMobile,
        log,
        setKakaoMapApiKey,
        setKakaoMapConfigs
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: "location",
        // OPTIONAL
        containerProps: {
            pb: {
                base: 0,
                md: "3rem"
            }
        },
        px: {
            base: 0,
            md: "2rem"
        },
        sectionProps: {
            pb: {
                base: 0,
                md: "3rem"
            }
        },
        sectionSize: section/* SectionSize.LG */.f3.LG,
        sectionType: section/* SectionType.LIGHT */.bA.LIGHT,
        title: (0,utils.t)("view.sections.location.title"),
        titleWrapProps: {
            mb: {
                base: "2rem",
                md: "3rem"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kakao_map, location_objectSpread({}, kakaoMapConfigs, {
            apiKey: kakaoMapApiKey,
            borderRadius: {
                base: 0,
                md: "20px"
            },
            height: 600
        }))
    }));
};
/* harmony default export */ var sections_location = (LocationSection);

;// CONCATENATED MODULE: ./src/views/contact/sections/index.ts




;// CONCATENATED MODULE: ./src/pages/contact.tsx








var ContactPage = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(layouts/* PageLayout */.Xg, {
        nextPageHref: null,
        seoProps: {
            title: (0,utils.t)("pages.home.seo.title"),
            description: (0,utils.t)("pages.home.seo.description")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_location, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Divider */.iz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Footer */.$_, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                src: "https://www.googletagmanager.com/gtag/js?id=AW-11334151501"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                id: "google-analytics",
                children: "\n        window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n\n        gtag('config', 'AW-11334151501');\n      "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                async: false,
                // strategy="lazyOnload"
                src: "//wcs.naver.net/wcslog.js",
                // eslint-disable-next-line react/no-unknown-property
                charSet: "UTF-8",
                onLoad: function(e) {
                    ;
                },
                onError: function(e) {
                    console.error("Script failed to load", e);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: "\n          var _nasa = {};\n          if (window.wcs) _nasa[\"cnv\"] = wcs.cnv(\"5\",\"10\"); // 전환유형, 전환가치 설정해야함. 설치매뉴얼 참고\n        "
                }
            })
        ]
    });
};
/* harmony default export */ var pages_contact = (ContactPage);


/***/ }),

/***/ 3613:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"kakao-map_container__E4PnY","zoomControl":"kakao-map_zoomControl___C5qx","button":"kakao-map_button__kXXFw"};

/***/ }),

/***/ 5525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"privacy-policy-modal_modal__mMYup","header":"privacy-policy-modal_header__8rtWh","title":"privacy-policy-modal_title__8WHRI","body":"privacy-policy-modal_body__Dd8YJ","phrase":"privacy-policy-modal_phrase__KJt_h","subtitle":"privacy-policy-modal_subtitle__SYDF1","footer":"privacy-policy-modal_footer__5ExUn","button":"privacy-policy-modal_button__H38Ly"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [890,279,201,768,603,593,422,461,339,818,806,774,888,179], function() { return __webpack_exec__(1430); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);